import { spawn } from 'utils/translations';
import { z } from 'zod';
import { DEVICE_CODE_PATTERN, FIELDS } from './consts';

/**
 * Validates the single device-code field. The CLI shows codes as `XXXX-XXXX`; we accept
 * the hyphen-less form too (`XXXXXXXX`) and re-insert the hyphen at submit, since the
 * backend compares the value hyphen-sensitively.
 */
export const getFormSchema = () => {
  const spawnText = spawn('device-code');

  return z.object({
    [FIELDS.CODE]: z
      .string()
      .trim()
      .min(1, spawnText('required'))
      .regex(DEVICE_CODE_PATTERN, spawnText('invalid-format')),
  });
};
